import routineReducerFactory from './routineReducerFactory';
import { fetchThemesData, fetchThemeData } from '../actions/routines';

export const themesInfo = routineReducerFactory(fetchThemesData, { data: [] });
export const themeInfo = routineReducerFactory(fetchThemeData, { data: [] });
